import { ProfileTypes } from '@/creditflowresearch/application/actions/profile/constants';
import { toSlug } from '@framework/url/helpers/toSlug';
import URL from '@/creditflowresearch/Router/urlConstants';
import { getMarketOverviewBreadcrumbsRoute } from '@/creditflowresearch/ui/common/helpers';

export const getProfileBreadcrumbs = (sectorOrIndustryData, filters) => {
  if (sectorOrIndustryData.profileType === ProfileTypes.OVERVIEW) {
    const marketOverviewBreadcrumb = getMarketOverviewBreadcrumbsRoute(filters);
    return [{
      title: marketOverviewBreadcrumb.title,
      isActive: true,
    }];
  }
  let breadcrumbsTale = [];
  if (sectorOrIndustryData.subitemName) {
    breadcrumbsTale = [
      {
        title: sectorOrIndustryData.itemName,
        url: `/${ toSlug(sectorOrIndustryData.itemName) }-${
          sectorOrIndustryData.profileType === ProfileTypes.SECTOR ? URL.SECTOR_SUFFIX : URL.INDUSTRY_SUFFIX
        }?products=${
          encodeURI(filters.products)
        }&regions=${
          encodeURI(filters.regions)
        }`,
      },
      {
        title: sectorOrIndustryData.subitemName,
        isActive: true,
      },
    ];
  } else {
    breadcrumbsTale = [
      {
        title: sectorOrIndustryData.itemName,
        isActive: true,
      },
    ];
  }
  return [
    getMarketOverviewBreadcrumbsRoute(filters),
    ...breadcrumbsTale,
  ];
};

export default getProfileBreadcrumbs;
